<template>
  <div>
    <p
      v-if="propsMode == 'edit' && quoteType == 'quote'"
      class="fw-700 text-info"
    >
      <span
        >Quote Id: <span class="text-black">{{ quoteId }}</span> |
      </span>

      <span
        >Status: <appWDQuoteStatusBadge :status="status" class="d-inline"
      /></span>
    </p>
    <p
      v-if="propsMode == 'edit' && quoteType == 'leads'"
      class="fw-700 text-info"
    >
      <span
        >Lead Id: <span class="text-black">{{ quoteId }}</span> |
      </span>

      <span
        >Status: <appWDLeadsStatusBadge :status="status" class="d-inline"
      /></span>
    </p>
  </div>
</template>
<script>
import appWDQuoteStatusBadge from './WDQuoteStatusBadge.vue'
import appWDLeadsStatusBadge from './WDLeadsStatusBadge.vue'
export default {
  name: 'WDStepTitle',
  props: ['propsMode', 'quoteType', 'quoteId', 'status'],
  components: {
    appWDQuoteStatusBadge,
    appWDLeadsStatusBadge
  }
}
</script>
